import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

import useContactFieldTemplates from "../../hooks/useContactFieldTemplates";
import { splitContactFields } from "../../helpers/contactFields";

const ALERT_RED = "#E53935";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    gap: 8,
    alignItems: "flex-start",
    padding: theme.spacing(1, 1.5),
    borderRadius: 8,
    border: `1px solid ${ALERT_RED}`,
    backgroundColor: `${ALERT_RED}1A`,
  },
  compact: {
    borderRadius: 0,
    borderLeft: "none",
    borderRight: "none",
    padding: theme.spacing(0.5, 1.5),
  },
  icon: {
    color: ALERT_RED,
    fontSize: 20,
    marginTop: 1,
    flexShrink: 0,
  },
  list: {
    display: "flex",
    flexWrap: "wrap",
    columnGap: 16,
    rowGap: 2,
  },
  name: {
    fontWeight: 700,
    color: ALERT_RED,
  },
}));

/**
 * Faixa vermelha com os campos de alerta preenchidos do contato
 * (ex.: "Alergias: Ácido salicílico"). Não renderiza nada se não houver.
 */
const ContactAlerts = ({ contact, compact = false, className, style }) => {
  const classes = useStyles();
  const templates = useContactFieldTemplates();

  if (!contact?.extraInfo?.length || !templates.length) return null;
  const { alerts } = splitContactFields(contact.extraInfo, templates);
  if (!alerts.length) return null;

  return (
    <div
      className={`${classes.box} ${compact ? classes.compact : ""} ${className || ""}`}
      style={style}
      role="alert"
    >
      <WarningIcon className={classes.icon} />
      <div className={classes.list}>
        {alerts.map((alert) => (
          <Typography key={alert.id || alert.name} variant="body2" component="span">
            <span className={classes.name}>{alert.name}:</span> {alert.value}
          </Typography>
        ))}
      </div>
    </div>
  );
};

export default ContactAlerts;
